export default "__VITE_ASSET__CUZXqAG3__"